<template>
    <el-form ref="scheduleForm" :model="scheduleForm" :rules="rules">
        <el-row>
            <el-col class="hidden-xs-only" style="width:20px">&nbsp;</el-col>
            <el-col :span="10" :xs="6">
                <el-form-item class="timepicker-col" prop="dateRange">
                    <el-date-picker align="center" format="yyyy/MM/dd" v-model="scheduleForm.dateRange" type="daterange" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :pickerOptions="pickerOptions" size="small" class="date-picker-width-small" @change='dateRangeChanged'></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="6" :xs="6">
                <el-form-item class="timepicker-col" prop="startTime">
                    <el-select v-model="scheduleForm.startTime" :disabled="scheduleForm.date==''" :clearable="true" size="small" placeholder="开始时间" @focus="onStartTimeFocus()" @change="startTimeChanged">
                        <el-option v-for="item in timesOfStartTime" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6" :xs="6">
                <el-form-item class="timepicker-col" prop="endTime">
                    <el-select v-model="scheduleForm.endTime" :disabled="scheduleForm.date==''" :clearable="true" size="small" placeholder="结束时间" @focus="onEndTimeFocus()" @change="endTimeChanged">
                        <el-option v-for="item in timesOfEndTime" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="1">
                <el-button class="timepicker-col-close" type="text" @click="deleteRow">
                    <i class="el-icon el-icon-close delete-row-icon"></i>
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<style lang="scss" scoped>
  .timepicker-col {
    width: auto;
  }

  .date-picker-width-small {
    width: 230px;
    margin-top: 5px;
  }
</style>

<script>
import { srcTimesOfDay } from "../service/api-base.service";
import { getStore } from "../config/mUtils";
export default {
  props: {
      rowIndex: Number,
      isSameAsAbove: Boolean,
      scheduleForm: Object,
      currentSchedulesAll: Array
  },
  data() {
    let _self = this;
    let dateRangeValidator = (rule, value, callback) => {
      if (!value || value.length < 2) {
        return callback(new Error("请选择日期范围"));
      }
      
      return callback();
    };
    let startTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择开始时间"));
      } else if (_self.scheduleForm.endTime !== "") {
        let timeSpan = parseInt(_self.scheduleForm.endTime) - parseInt(value);
        if (timeSpan <= 0) {
          return callback(new Error("开始时间应早于结束时间"));
        }
        return callback();
      } else {
        return callback();
      }
    };
    let endTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择结束时间"));
      } else if (_self.scheduleForm.startTime !== "") {
        let timeSpan = parseInt(value) - parseInt(_self.scheduleForm.startTime);
        if (timeSpan <= 0) {
          return callback(new Error("结束时间应晚于开始时间"));
        }
        return callback();
      } else {
        return callback();
      }
    };

    return {
      currentDate: new Date(),
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      timesOfDay: srcTimesOfDay(),
      dateRange: [],
      timesOfStartTime: srcTimesOfDay(),
      timesOfEndTime: srcTimesOfDay(),
      rules: {
        dateRange: [
          {
            validator: dateRangeValidator,
            trigger: "blur"
          }
        ],
        startTime: [
          {
            validator: startTimeValidator,
            trigger: "blur"
          }
        ],
        endTime: [
          {
            validator: endTimeValidator,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    disabledDate(time) {
      let dayOfWeek = time.getDay();
      dayOfWeek = dayOfWeek != 0 ? dayOfWeek : 7;

      if (time.getFullYear() != this.currentDate.getFullYear())
        return time.getFullYear() < this.currentDate.getFullYear();
      
      if (time.getMonth() != this.currentDate.getMonth())
        return time.getMonth() < this.currentDate.getMonth();

      return time.getDate() < this.currentDate.getDate();
    },
    validateRow() {
      let validResult = false;
      this.$refs.scheduleForm.validate(valid => {
        validResult = valid;
      });
      return validResult;
    },
    onStartTimeFocus() {
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.$data.timesOfDay.forEach((item, index) => {
        if (index == 0) {
          if (this.$props.rowIndex > 0 && this.$props.isSameAsAbove)
            item.disabled = false;
        } else {
          item.disabled = false;
        }
        item.hide = false;
        if (this.$props.scheduleForm.endTime > 0) {
          if (item.value >= parseInt(this.$props.scheduleForm.endTime)) {
            item.disabled = true;
            item.hide = true;
          }
        }
      });
      this.timesOfStartTime = [];
      this.$data.timesOfDay.forEach((item, index) => {
        if (!item.hide) {
          this.timesOfStartTime.push(item);
        }
      });
    },
    onEndTimeFocus() {
      let self = this;
      this.$emit("editRow", this.$props.scheduleForm.id);
      this.$data.timesOfDay.forEach((item, index) => {
        if (index == 0) {
          if (self.$props.rowIndex > 0 && self.$props.isSameAsAbove)
            item.disabled = false;
        } else {
          item.disabled = false;
        }
        item.hide = false;
        if (self.$props.scheduleForm.startTime > 0) {
          if (item.value <= parseInt(self.$props.scheduleForm.startTime)) {
            item.disabled = true;
            item.hide = true;
          }
        }
      });
      this.timesOfEndTime = [];
      this.$data.timesOfDay.forEach((item, index) => {
        if (!item.hide) {
          this.timesOfEndTime.push(item);
        }
      });
    },
    dateRangeChanged(value) {
      this.$emit("editRow", this.$props.scheduleForm.id);
    },
    startTimeChanged(value) {
      if (value === 0) {
        let currentUnailbeTime = this.$props.currentSchedulesAll;
        if (currentUnailbeTime.length > 1) {
          this.onEndTimeFocus();
          let index = currentUnailbeTime.length - 2;
          this.$props.scheduleForm.startTime =
            currentUnailbeTime[index].startTime;
          this.$props.scheduleForm.endTime = currentUnailbeTime[index].endTime;
        }
      }
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          if (value === 0) {
            this.$props.scheduleForm.startTime = "";
            this.$props.scheduleForm.endTime = "";
          }
          return;
        }
      });
    },
    endTimeChanged(value) {
      if (value === 0) {
        let currentUnailbeTime = [];
        if (currentUnailbeTime.length > 0) {
          this.onStartTimeFocus();
          let index = currentUnailbeTime.length - 1;
          this.$props.scheduleForm.startTime =
            currentUnailbeTime[index].startTime;
          this.$props.scheduleForm.endTime = currentUnailbeTime[index].endTime;
        }
      }
      this.$refs.scheduleForm.validate(valid => {
        if (!valid) {
          if (value === 0) {
            this.$props.scheduleForm.startTime = "";
            this.$props.scheduleForm.endTime = "";
          }
          return;
        }
      });
    },
    deleteRow() {
      this.$emit("deleteRow", this.$props.scheduleForm.id);
    }
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/computerUnavailableTimeScheduleTimePicker.vue